<app-smart-link [customClass]="'event-new-event-container'" [route]="route">
  <div class="event-new-event-button">
    <img class="event-new-event-img" [src]="imagePath" />
  </div>
  <div class="event-text">{{ text }}</div>
</app-smart-link>
